import { useEffect } from 'react';
import Modal from 'react-modal'; // It can be any modal
import { useMediaQuery } from 'react-responsive';
import { MODALS, MODAL_TYPES } from 'src/@types/navigation';
import { SCREENS } from 'src/constants/strings';
import errorIcon from 'src/images/error_modal/alert.svg';
import { Box, Text } from 'src/theme';
import { mobileMaxWidth } from 'src/utils/responsiveSize';

export default function ErrorModal({
  isOpen,
  onClose,
  title = SCREENS.ERROR_MODAL_TITLE,
  subTitle = SCREENS.ERROR_MODAL_SUB_TITLE,
  contentStyle,
}: MODALS[MODAL_TYPES.ERROR]): JSX.Element {
  const isMobile = useMediaQuery({ query: mobileMaxWidth });

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <Modal
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: '#3737372E',
        },
        content: contentStyle,
      }}
      isOpen={isOpen}
      onRequestClose={onClose}>
      <Box textAlign={'center'} px={isMobile ? 5 : 80} py={20}>
        <Box p={10}>
          <img src={errorIcon} alt="saveIcon" />
        </Box>
        <Text fontSize={18}>{title}</Text>
        <Text color={'grey7a7a7a'}>{subTitle}</Text>
      </Box>
    </Modal>
  );
}
